import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => {
  return {
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    image: {
      width: '500px',
      maxWidth: '50%',
      marginBottom: 57,
    },
    title: {
      fontWeight: 'bold',
      letterSpacing: '0.02em',
      color: '#4F5057',
      marginBottom: 10,
    },
    text: {
      fontSize: 20,
      color: '#727379',
    },
    button: {
      marginTop: 30,
      width: '100%',
      maxWidth: 550,
      textTransform: 'initial',
    },
  }
})
